import React, {useState} from 'react';
import {MenuLateralAA} from '../menuLateralAA/MenuLateralAA';
import {HeadUserFeedback} from './HeadUserFeedback';
import {TablasUserFeedback} from './TablasUserFeedback';
import 'react-dropdown/style.css';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import {useSessionStore} from '../../hooks/useSessionStore';
import {TablaUserFeecback} from './TablaUserFeecback';
import {CrearEncuesta} from './CrearEncuesta';
import {EncuestasRecurrentes} from './EncuestasRecurrentes';

export const ContentBodyUserFeedback = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;
	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	/* Setting the state of the TipoNotificaciones variable to an array of strings. */
	const [TipoNotificaciones, setTipoNotificaciones] = useState([
		['buttonNotificaciones', 'Tablas'],
		['buttonNotificacionesActive', 'Crear encuesta'],
		['buttonNotificaciones', 'Encuestas recurrentes'],
	]);

	/**
	 * It takes a number as an argument and then sets the state of the component to a list of strings,
	 * where the string at the index of the number argument is set to a different string
	 */
	const cambioNotificaciones = (num) => {
		let listaAxu = [
			['buttonNotificaciones', 'Tablas'],
			['buttonNotificaciones', 'Crear encuesta'],
			['buttonNotificaciones', 'Encuestas recurrentes'],
		];
		listaAxu[num] = ['buttonNotificacionesActive', listaAxu[num][1]];
		setTipoNotificaciones(listaAxu);
	};

	return (
		<div className='ContentUserFeedback'>
			{
				<MenuLateralAB
					seleccionado={3}
					MenuLateralAux={MenuLateralAux}
					chageMenuLateralAux={chageMenuLateralAux}
				/>
			}
			{/* Esta es la posicon del boton qu se ha de estar seleccionado*/}
			<div className='derContentUserFeedback'>
				<HeadUserFeedback
					TipoNotificaciones={TipoNotificaciones}
					setTipoNotificaciones={setTipoNotificaciones}
					cambioNotificaciones={cambioNotificaciones}
				/>
				{
					// Seleccion del contenido del body de la pagina
					TipoNotificaciones.map((seleccion) =>
						seleccion[0] === 'buttonNotificacionesActive' &&
						seleccion[1] === 'Tablas' ? (
							<TablasUserFeedback />
						) : seleccion[0] === 'buttonNotificacionesActive' &&
						  seleccion[1] === 'Crear encuesta' ? (
							<CrearEncuesta />
						) : (
							seleccion[0] === 'buttonNotificacionesActive' &&
							seleccion[1] === 'Encuestas recurrentes' && <EncuestasRecurrentes />
						)
					)
				}
			</div>
		</div>
	);
};
